import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AppRoute } from "@app/models/AppRoute";
import { startDatadogView } from "@services/datadog";

const routePatterns = Object.values(AppRoute);

/**
 * Drives manual Datadog RUM view tracking for react-router v5: reports the
 * initial view and every subsequent navigation, named by the matched route
 * pattern. No-op when RUM is disabled (guarded inside startDatadogView).
 */
const useDatadogViewTracking = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    startDatadogView(location.pathname, routePatterns);

    const unlisten = history.listen((newLocation) => {
      startDatadogView(newLocation.pathname, routePatterns);
    });

    return () => unlisten();
    // Run once on mount; the listener handles subsequent navigations.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
};

export default useDatadogViewTracking;
